import { render, staticRenderFns } from "./PortionTree.vue?vue&type=template&id=50e2f2e3&"
import script from "./PortionTree.vue?vue&type=script&lang=js&"
export * from "./PortionTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports